import React, { useState } from 'react';

import { useSelector } from 'react-redux';

import './FormField.scss';
import { validate } from './helpers';

export default function FormField({ type, hint, value, onChange, valid }) {
  const [validIndicator, setValidIndicator] = useState(
    value ? (valid ? 'success' : 'error') : 'start',
  );
  const formFieldErrors = useSelector((store) => store.data.formFieldErrors);

  const onChangeInput = (e) => {
    onChange(
      e.target.value,
      validate(e.target.value, type) === 'success',
    );
  };

  const onBlur = (e) => setValidIndicator(validate(e.target.value, type));

  const ErrorMsg = ({ text }) => {
    if (validIndicator === 'error') {
      return (
        <div className="FormField-validateText-container">
          <p className="FormField-validateText">{text}</p>
        </div>
      );
    }

    return null;
  };

  return (
    <div className="FormField-container">
      <input
        className={`${
          validIndicator === 'start'
            ? 'FormField-start'
            : validIndicator === 'success'
            ? 'FormField-success'
            : 'FormField-error'
        }`}
        type="text"
        placeholder={hint}
        value={value}
        onChange={onChangeInput}
        onBlur={onBlur}
      />
      <ErrorMsg text={formFieldErrors[type]} />
    </div>
  );
}
